import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "login",
  "use": "login-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"login\"><path d=\"M11.733 11.307l2.667 2.667H3.52v3.52H14.4l-2.667 2.773 2.453 2.453 6.933-6.933-6.933-6.933-2.453 2.453zm6.08 13.546H28.48v3.52H17.813v-3.52zM28.48 3.52H32v24.853h-3.52V3.52zm-10.667 0H28.48v3.52H17.813V3.52z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol